



























































































































import "./project-setup.less";
import Vue from "vue";
import iForm from "iView";
import moment from "moment";
import { Model } from "vue-property-decorator";
import { mapState, mapGetters } from "vuex";
import VueTagsInput from "@johmun/vue-tags-input";
import DefinedColorPicker from "./../common/defined-color-picker.vue";
import UserAvatar from "../common/user-avatar.vue";
let _ = require("lodash");

export default Vue.extend({
  name: "project-setup",
  components: {
    VueTagsInput,
    DefinedColorPicker,
    UserAvatar,
  },
  props: {
    project: Object,
    showEditor: Boolean,
  },
  data() {
    return {
      rules: {
        name: [
          {
            required: true,
            message: "Please fill in the Project Name",
            trigger: "blur",
          },
          {
            type: "string",
            max: 40,
            message: "Please limit your Project Name to max 40 characters. Thanks!",
            trigger: "blur",
          },
        ],
        description: [
          {
            type: "string",
            max: 1200,
            message: "Please limit your Project Description to max 1,200 characters. Thanks!",
            trigger: "blur",
          },
        ],
        color: [
          {
            type: "string",
            required: true,
            message: "Please pick the color for the project card.",
            trigger: "blur",
          },
        ],
        completedPercentage: [
          {
            type: "number",
            min: 0,
            max: 10000,
            message: "Completed percentage must be between 0 and 10000.",
            trigger: "change",
          },
        ],
        hashTagList: [
          {
            type: "array",
            required: true,
            message: "Please fill in the Grouping Tags",
            trigger: "change",
          },
        ],
        members: [
          {
            type: "array",
            required: true,
            message: "Please select a member",
            validator: (rule, value, callback) => {
              if (value && value.filter((member) => member.selected === true).length > 0) {
                callback();
              } else {
                callback(new Error("Error!"));
              }
            },
          },
        ],
      },
      memberRules: {
        role: [
          {
            type: "number",
            required: true,
            message: "Please select a role",
            trigger: "change",
          },
        ],
      },
      activePage: "",
      tag: "",
      tags: [],
      currentProject: {
        name: null,
        description: "",
        hashTags: "",
        hashTagList: [],
        color: "#0178B5",
        completedPercentage: NaN,
        completed: false,
        members: [],
        teams: [],
      },
    };
  },
  computed: {
    ...mapGetters("billing", ["activeUsers"]),
    ...mapGetters("project", ["currentProjectInviteRoles", "canEdit"]),
    ...mapState("team", ["teams"]),
    showModal(): boolean {
      return this.showEditor;
    },
    detailsCompleted(): any {
      let project = this.currentProject;
      return project.name != null && project.hashTagList.length > 0 && project.color != null;
    },
    membersCompleted(): any {
      return true;
    },
    teamsCompleted(): any {
      return true;
    },
  },
  watch: {
    showModal(newVal) {
      this.gotoPage("details");

      if (newVal === true) {
        this.currentProject.name = this.project.name;
        if (!!this.project.color) {
          this.currentProject.color = this.project.color;
        } else {
          this.currentProject.color = "#0178B5";
        }
        this.currentProject.completedPercentage = this.project.completedPercentage;
        this.currentProject.description = this.project.description;
        this.currentProject.hashTags = this.project.hashTags;
        this.currentProject.hashTagList = this.currentProject.hashTags ? JSON.parse(this.currentProject.hashTags) : [];
        this.currentProject.completed = this.project.completed;

        let context = this as any;
        this.currentProject.members = context.activeUsers.map((user) => {
          let result = Object.assign({}, user);

          let member = _.find(this.project.members, function (member) {
            return user.memberId === member.memberId;
          });

          result.selected = !!member;
          result.role = !!member ? member.role : null;

          return result;
        });

        if (context.teams) {
          this.currentProject.teams = context.teams.map((team) => {
            let result = Object.assign({}, team);

            let selectedTeam = _.find(this.project.teams, function (item) {
              return item.teamId === team.id;
            });

            result.selected = !!selectedTeam;

            return result;
          });
        }

        let hiddenTeams = this.project.teams.filter((item) => !context.teams || context.teams.filter((team) => team.id == item.teamId).length == 0);
        if (hiddenTeams.length > 0) {
          this.currentProject.teams = this.currentProject.teams.concat(
            hiddenTeams.map((item) => {
              return { id: item.teamId, name: item.teamName, selected: true, hidden: true, members: item.teamMembers };
            })
          );
        }
      }
    },
  },
  created() {
    this.$store.dispatch("team/getMyTeams", {});
  },
  mounted() {
    (this.$refs.ColorPicker as any).setDropIndexGetter((this.$refs.MainModal as any).handleGetModalIndex);
  },
  methods: {
    handleHidden(visible) {
      if (!visible) {
        try {
          (this.$refs.SetupForm as any).resetFields();
        } catch (error) {}
      }
    },
    tagsChanged(newTags) {
      this.currentProject.hashTagList = newTags;
      (this.$refs.SetupForm as any).validateField("hashTagList");
    },
    checkMember(member) {
      member.selected = !member.selected;
    },
    checkTeam(team) {
      team.selected = !team.selected;
    },
    handleSave() {
      event.preventDefault();
      let target = (event.target as any).closest("button") as HTMLButtonElement;
      target.disabled = true;
      let form = this.$refs.SetupForm;

      (this.$refs.SetupForm as any).validate((valid: boolean) => {
        if (valid) {
          let projectDto = {
            id: this.project.id,
            name: this.currentProject.name,
            color: this.currentProject.color,
            completedPercentage: this.currentProject.completedPercentage,
            description: this.currentProject.description,
            hashTags: JSON.stringify(this.currentProject.hashTagList),
            completed: this.currentProject.completed,
          };

          projectDto[this.project.id ? "updatedMembers" : "members"] = this.currentProject.members
            .filter((member) => member.selected === true)
            .map((member) => {
              return { memberId: member.memberId, role: member.role, accepted: true };
            });

          projectDto["teams"] = this.currentProject.teams
            .filter((team) => team.selected === true)
            .map((team) => {
              return { teamId: team.id };
            });

          let actionName = this.project.id ? "project/update" : "project/create";
          let context = this;
          context.$store.dispatch(actionName, { data: projectDto }).then((response) => {
            context.$emit("cancel");
            context.$emit("saved");
            target.disabled = false;
          });
        } else {
          let fields = (form as any).fields.filter((field) => field.validateState === "error");
          if (fields != null && fields.length > 0) {
            let page = fields[0].$el.closest(".tab-content-wrap");
            if (page != null) {
              let pageName = page.getAttribute("name");
              this.gotoPage(pageName);
            }
          }

          target.disabled = false;
        }
      });
    },
    handlerWizardStep(forward) {
      let steps = ["details", "members", "teams"];
      let nextStepIndex = _.findIndex(steps, (step) => step === this.activePage) + (forward ? 1 : -1);
      this.gotoPage(steps[nextStepIndex]);
    },
    gotoPage(name) {
      this.activePage = name;
    },
    selectHandler(item) {
      this.activePage = item;
    },
  },
});
